import axios from "axios";
import { ActionType } from "../action-types";
import { http } from "../../utils/http";

import { UnlockReasonsState, UnlockReasonDto } from "../../dto/unlockReasons";
import { AppThunk } from "./index";

export const setUnlockReasons = (payload: UnlockReasonsState) => ({
  type: ActionType.SET_UNLOCK_REASONS,
  payload,
});

export const fetchUnlockReasons = (): AppThunk<Promise<void>> => {
  return async (dispatch, getState) => {
    const jwt = getState().token;
    if (!jwt) throw new Error("Missing JWT!");

    try {
      const res = await http.get("/api/unlockreasons");
      const data = res.data;
      const reasons: UnlockReasonDto[] = data?.reasons ?? [];

      dispatch(setUnlockReasons({ reasons }));
    } catch (error) {
      if (axios.isAxiosError(error)) {
        const status = error.response?.status ?? "NO_STATUS";
        const text =
          typeof error.response?.data === "string"
            ? error.response.data
            : JSON.stringify(error.response?.data ?? "");
        throw new Error(
          `GET /api/unlockreasons failed REQUEST: ${status} ${text}`
        );
      }
      throw error;
    }
  };
};
